export default __webpack_public_path__ + "static/media/TicketBig.5f34e365.svg";